import React from 'react';
import MyCard from "./myCard";
import DivTable from "./divTable";

function Commande(props) {
    return (
        <section>
            <MyCard header={"Commande #" + props.CommandeID}
                    body={
                        <>
                            <div>
                                Passée le {new Date(props.CommandeDateHeure).toLocaleString()} pour un montant total
                                de <b>{props.CommandeMontantDisplay}</b> à payer avec la communication
                                structurée <b>{props.CommandeVCS}</b> sur le compte BE16 7320 0631 7074.
                            </div>
                            <p><u>Statut</u>: {props.CommandePaye ? "Payée" : "Non payée"}</p>
                            <DivTable columns={{
                                "Type support": "TypeSupportCours",
                                "Support": "SupportCoursLibelle",
                                "Activité(s) d'Apprentissage liée(s)": "ActiviteApprentissageLiees",
                                "Prix unitaire": "SupportCoursPrixDisplay",
                                "Quantité": "LigneCommandeQuantite"
                            }}
                                      array={props.details}/>
                        </>
                    }/>
        </section>
    );
}

export default Commande;